<template>
  <b-form-group :label="label" :label-class="labelClass">
    <b-input-group :class="{ readonly: disabled }">
      <template #append>
        <b-input-group-text @click="openLinkValueInNewTab" v-if="value" class="button">
          <b-icon style="width:14px" v-if="icon" :icon="icon" />
        </b-input-group-text>
      </template>
      <b-input
        type="url"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event)"
        @keyup="$emit('keyup', arguments)"
        @focus="$emit('focus', arguments[0])"
        :required="required"
        :disabled="disabled"
      />
    </b-input-group>
  </b-form-group>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    }
  },
  methods: {
    openLinkValueInNewTab() {
      // when clicked, open the link "value" in a new tab^
      if (this.value) window.open(this.value, '_blank');
    }
  }
};
</script>
